import { forwardRef, useId } from 'react';

const GlassInput = forwardRef(function GlassInput(
  {
    id,
    label,
    type = 'text',
    value,
    onChange,
    placeholder,
    isInvalid = false,
    disabled = false,
    suffix,
    prefix,
    inputMode,
    min,
    max,
    step,
    className = '',
    ...rest
  },
  ref,
) {
  const generatedId = useId();
  const inputId = id ?? generatedId;
  const hasAffix = Boolean(prefix || suffix);

  return (
    <div className={`relative ${className}`}>
      {prefix && (
        <span className="pointer-events-none absolute inset-y-0 left-4 flex items-center text-sm font-medium text-white/40">
          {prefix}
        </span>
      )}
      <input
        ref={ref}
        id={inputId}
        type={type}
        value={value ?? ''}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        inputMode={inputMode}
        min={min}
        max={max}
        step={step}
        aria-label={label}
        aria-invalid={isInvalid || undefined}
        className={`glass-input w-full rounded-2xl py-3 text-base text-white/95 placeholder:text-white/35 ${prefix ? 'pl-10' : 'pl-4'} ${suffix ? 'pr-14' : 'pr-4'} ${isInvalid ? 'is-invalid' : ''}`}
        {...rest}
      />
      {suffix && (
        <span className="pointer-events-none absolute inset-y-0 right-4 flex items-center text-xs font-mono uppercase tracking-wider text-white/45">
          {suffix}
        </span>
      )}
      {hasAffix && <span className="sr-only">{label}</span>}
    </div>
  );
});

export default GlassInput;